import { render, staticRenderFns } from "./matrixFields.vue?vue&type=template&id=2f1cd522&"
import script from "./matrixFields.vue?vue&type=script&lang=js&"
export * from "./matrixFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports